import { createSelector } from 'reselect';

import { getCanManageTier } from 'selectors/session';

export const selectRemoveLocationsError = state =>
  state.get('enforcement').removeLocationsError;

export const selectRemoveLocationsPending = state =>
  state.get('enforcement').removeLocationsPending;

export const selectRemovedLocations = state =>
  state.get('enforcement').removedLocations;

export const selectSelectedTierName = state =>
  state.get('enforcement').selectedTierName;

export const selectSelectedLocationsById = state =>
  state.get('enforcement').selectedLocationsById;

export const selectStep = state => state.get('enforcement').step;

// The ee caps enforcement paywall
export const selectDisplayDialog = state =>
  state.getIn(['session', 'enforcement', 'displayDialog']);

export const selectShouldShowEnforcementDialogOnInitialLoad = createSelector(
  selectDisplayDialog,
  getCanManageTier,
  (displayDialog, canManageTier) => displayDialog && canManageTier
);
